export default {
  state: {
    main: {
      //DO NOT REORDER
      about: ['overview', 'intro', 'products', 'our-purpose', 'directors-board', 'community'],
      products: ['overview', 'intro', 'products', 'quality'],
      sustainability: ['overview', 'priorities', 'importance', 'framework', 'highlights'],
      careers: ['overview', 'values', 'benefits', 'jobs', 'scholarships'],
      blog: [],
    },
    policies: ['accessibility', 'privacy', 'disclaimer', 'sms'],
  },
}
